import { render, staticRenderFns } from "./CompraGTM.vue?vue&type=template&id=3987f3e2&scoped=true&"
import script from "./CompraGTM.vue?vue&type=script&lang=js&"
export * from "./CompraGTM.vue?vue&type=script&lang=js&"
import style0 from "./CompraGTM.vue?vue&type=style&index=0&id=3987f3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987f3e2",
  null
  
)

export default component.exports